import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-733e0228")

_pushScopeId("data-v-733e0228")
const _hoisted_1 = { class: "schedule__update" }
const _hoisted_2 = {
  key: 0,
  class: "update__group"
}
const _hoisted_3 = { class: "update__title update__title--import" }
const _hoisted_4 = { class: "update__title--action" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-text" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "update__title--text" }, "Import d'un fichier [.csv]", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "update__title--extra" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Écraser les matchs courant", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Annuler si une erreur survient", -1)
const _hoisted_11 = {
  key: 1,
  class: "icon-spinner animate-spin"
}
const _hoisted_12 = {
  key: 2,
  class: "icon-select2"
}
const _hoisted_13 = { class: "update__group" }
const _hoisted_14 = { class: "update__title" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "update__title--text"
}
const _hoisted_17 = {
  key: 1,
  class: "update__title--text"
}
const _hoisted_18 = { class: "table" }
const _hoisted_19 = { class: "table__header row" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"header__cell cell cell--info cell--data\" data-v-733e0228><span data-v-733e0228><i class=\"icon-info-circled\" data-v-733e0228></i> Match</span></div><div class=\"header__cell cell cell--date cell--data\" data-v-733e0228><span data-v-733e0228><i class=\"icon-calendar\" data-v-733e0228></i> Date</span></div><div class=\"header__cell cell cell--time cell--data\" data-v-733e0228><span data-v-733e0228><i class=\"icon-clock\" data-v-733e0228></i> Heure</span></div><div class=\"header__cell cell cell--field cell--data\" data-v-733e0228><span data-v-733e0228><i class=\"icon-location\" data-v-733e0228></i> Terrain</span></div>", 4)
const _hoisted_24 = {
  key: 0,
  class: "header__cell cell cell--team"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-team" }),
  /*#__PURE__*/_createTextVNode(" Équipes")
], -1)
const _hoisted_26 = { class: "table__body" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "cell cell--info cell--data" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "icon-calendar" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "icon-clock" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "icon-spinner animate-spin"
}
const _hoisted_33 = { class: "cell cell--date cell--data" }
const _hoisted_34 = { class: "cell cell--time cell--data" }
const _hoisted_35 = { class: "cell cell--field cell--data" }
const _hoisted_36 = {
  key: 0,
  class: "icon-spinner animate-spin"
}
const _hoisted_37 = {
  key: 0,
  class: "cell cell--team"
}
const _hoisted_38 = { class: "cell--team-name" }
const _hoisted_39 = { class: "team-name team-name--right" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "delimiter" }, "–", -1)
const _hoisted_41 = { class: "team-name team-name--left" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FileUpload = _resolveComponent("FileUpload")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_TheScheduleImportReport = _resolveComponent("TheScheduleImportReport")
  const _component_Datepicker = _resolveComponent("Datepicker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.fileImport)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_FileUpload, {
                ext: ['csv'],
                onFileUpload: _ctx.importSchedule
              }, {
                default: _withId(() => [
                  _createVNode("div", {
                    class: ["update__title--icon button button--action", {'button--disabled': _ctx.addMatchLoading}]
                  }, [
                    _hoisted_5
                  ], 2),
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onFileUpload"]),
              (_ctx.fileSchedule.fileName !== null)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("span", {
                      class: "update__title--filename",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleImportReport && _ctx.toggleImportReport(...args)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.fileSchedule.fileName) + " ", 1),
                      (_ctx.hasImportReport)
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            class: {
                                    'icon-eye': !_ctx.importReportVisible,
                                    'icon-eye-off': _ctx.importReportVisible
                                }
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_Checkbox, {
                value: "overwrite",
                checked: _ctx.overwrite,
                onToggle: _ctx.toggleOverwrite
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["checked", "onToggle"]),
              _createVNode(_component_Checkbox, {
                value: "stopOnError",
                checked: _ctx.stopOnError,
                onToggle: _ctx.toggleStopOnError
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["checked", "onToggle"])
            ]),
            (_ctx.addMatchError && _ctx.fileSchedule.fileName)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  title: _ctx.addMatchErrMsg,
                  class: "icon-attention"
                }, null, 8, ["title"]))
              : (_ctx.addMatchLoading && _ctx.fileSchedule.fileName)
                ? (_openBlock(), _createBlock("i", _hoisted_11))
                : (_ctx.addMatchReady && _ctx.fileSchedule.fileName)
                  ? (_openBlock(), _createBlock("i", _hoisted_12))
                  : _createCommentVNode("", true)
          ]),
          (_ctx.importReportVisible)
            ? (_openBlock(), _createBlock(_component_TheScheduleImportReport, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _createVNode("div", {
          class: ["update__title--icon button button--action", {'button--disabled': !_ctx.matchAddValid && !_ctx.timeslotAddValid}],
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addToSchedule && _ctx.addToSchedule(...args)))
        }, [
          _hoisted_15
        ], 2),
        (_ctx.matchUpdate)
          ? (_openBlock(), _createBlock("span", _hoisted_16, " Ajouter un match"))
          : (_openBlock(), _createBlock("span", _hoisted_17, " Ajouter une plage horaire"))
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          (_ctx.matchUpdate)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _hoisted_25
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("span", null, [
                _hoisted_29,
                _createVNode(_component_Datepicker, {
                  class: "date-picker--custom",
                  modelValue: _ctx.addMatchDateSelected,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addMatchDateSelected = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode("span", null, [
                _hoisted_30,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addMatchTimeSelected = $event))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableTime, (time, ix) => {
                    return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(time), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.addMatchTimeSelected]
                ])
              ]),
              _createVNode("span", null, [
                _hoisted_31,
                (_ctx.fieldsLoading)
                  ? (_openBlock(), _createBlock("i", _hoisted_32))
                  : _withDirectives((_openBlock(), _createBlock("select", {
                      key: 1,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.addMatchFieldSelected = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedFields, (field, ix) => {
                        return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(field), 1))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.addMatchFieldSelected]
                    ])
              ])
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.addMatchDateSelected,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addMatchDateSelected = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_34, [
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.addMatchTimeSelected = $event))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableTime, (time, ix) => {
                  return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(time), 1))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.addMatchTimeSelected]
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              (_ctx.fieldsLoading)
                ? (_openBlock(), _createBlock("i", _hoisted_36))
                : _withDirectives((_openBlock(), _createBlock("select", {
                    key: 1,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.addMatchFieldSelected = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedFields, (field, ix) => {
                      return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(field), 1))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.addMatchFieldSelected]
                  ])
            ]),
            (_ctx.matchUpdate)
              ? (_openBlock(), _createBlock("div", _hoisted_37, [
                  _createVNode("div", _hoisted_38, [
                    _createVNode("div", _hoisted_39, [
                      _withDirectives(_createVNode("select", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.addMatchHomeSelected = $event))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team, ix) => {
                          return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.addMatchHomeSelected]
                      ])
                    ]),
                    _hoisted_40,
                    _createVNode("div", _hoisted_41, [
                      _withDirectives(_createVNode("select", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.addMatchAwaySelected = $event))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team, ix) => {
                          return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.addMatchAwaySelected]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
})